import { render, staticRenderFns } from "./UploadResumeSection.vue?vue&type=template&id=5b506a8c&"
import script from "./UploadResumeSection.vue?vue&type=script&lang=ts&"
export * from "./UploadResumeSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports